//모든 태그요소 제거
export function removeAllTag(str){

    const remove =str.replace(/(<([^>]+)>)/ig,"");
    const remove2 =remove.replace(/&nbsp;/gi,"");
    return remove2;
}
